export default __webpack_public_path__ + "static/media/home_background.004a32f3.png";